import Tile from 'ol/layer/tile'
import SourceTileWMS from 'ol/source/tilewms'
import GeoJSONFormat from 'ol/format/geojson'

// import WFSFormat from 'ol/format/wfs'
import config from '../config'

import WPSProvider from './wps'

const GeoJSONParser = new GeoJSONFormat()

const geoserverWorkspace = config.geoserver.geoserverWorkspace
const geoserverURL = `${config.geoserver.geoserverURL}/${geoserverWorkspace}/wms`

export function getRastersAverage(layers) {
  const layerCrop = `${config.geoserver.geoserverWorkspace}:ambito`

  return Promise.all(layers.map(layer => 
    WPSProvider.RasterAverage(layer, layerCrop)
    .then(featureCollection => featureCollection.features[0].properties)
    .then(({ avg, min, max, stddev }) => ({ avg, min, max, stddev }))
  ))
}

/*
 **** getFeatureInfo
 **** Realiza una petición GetFeatureInfo a Geoserver
 **** @param {ol.Coordinate} coordinate -- coordenada para realizar la búsqueda
 **** @param {ol.Map} map -- El mapa actual}
 **** @param {string} searchMode -- Modo de búsqueda }
*/
export function getFeatureInfo(layersArray, coordinate, map) {
  const layers = layersArray.map(({name}) => name).join(',')
  
  const url = new SourceTileWMS({ url: geoserverURL, params: { layers } }).getGetFeatureInfoUrl(
    coordinate, 
    map.getView().getResolution(),
    map.getView().getProjection(),
    {
      info_format: 'application/json',
      feature_count: layersArray.length,
      query_layers: layers
    }
  ) 
 
  return fetch(url)
    .then(res => res.json())
    .then( ({features}) => features.map(({properties}) => properties.GRAY_INDEX) )
}

/*
 **** getPolygonStats
 **** Realiza una petición WPS (RasterZonalStatistics) a Geoserver
 **** @param {ol.Feature} feature -- Polígono para realizar la búsqueda
 **** @param {string} searchMode -- Modo de búsqueda
*/
export function getPolygonStats(layers, feature) {
  let geojsonFeature = GeoJSONParser.writeFeatureObject(feature)
  
  delete geojsonFeature.properties

  let geojsonExport = {
    type: 'FeatureCollection',
    features: [
      geojsonFeature
    ],
    crs: {
      type: 'name',
      properties: {
        name: 'urn:ogc:def:crs:EPSG::25830'
      }
    }
  }
  
  geojsonExport = JSON.stringify(geojsonExport)


  return Promise.all(layers.map(layer => 
    WPSProvider.RasterZonalStats(geojsonExport, layer)
      .then(featureCollection => featureCollection.features[0].properties)
      .then(({ avg }) => avg)
      .catch( (e) => e)
  ))
  
}

/**
 * 
 * @param {} polygon 
 */
export function getPopulation(feature) {
  const geojsonFeature = GeoJSONParser.writeFeaturesObject([feature])
  delete geojsonFeature.features[0].properties

  const epsgNumber = '25830'
  geojsonFeature.crs = {
    type: 'name',
    properties: {
      name: `urn:ogc:def:crs:EPSG::${epsgNumber}`
    }
  }

  const geojsonExport = JSON.stringify(geojsonFeature)
  const calcPercentages = feature.getGeometry().getType() !== 'Point'
  const layer = { name: `${geoserverWorkspace}:poblacion` }
  const validFields = ['POBLACION']

  return WPSProvider.Intersection(geojsonExport, layer, calcPercentages)
    .then(featureCollection => 
      validFields.map(field =>
        featureCollection.features
          .map(({properties: { [`poblacion_${field}`]: value } }) => value)
          .reduce((a, b) => a + b, 0)
      )
      .map(Math.ceil)
      .reduce((obj, value, index) => (obj[validFields[index]] = value) && obj, {})
    )
    .catch(() => validFields.reduce((obj, value, index) => (obj[validFields[index]] = value) && obj, {}))
}

export function getGeoJSONZonaVerde(polygon, layer) {
  const geojsonFeature = GeoJSONParser.writeFeaturesObject([polygon])
  delete geojsonFeature.features[0].properties

  const {
    nativeBoundingBox: { crs: { $: projection } }
  } = layer

  const epsgNumber = projection.replace('EPSG:', '')

  geojsonFeature.crs = {
    type: 'name',
    properties: {
      name: `urn:ogc:def:crs:EPSG::${epsgNumber}`
    }
  }

  const geojsonExport = JSON.stringify(geojsonFeature)
  //console.log(geojsonExport)
  return WPSProvider.Intersection(geojsonExport, layer, false)
}


// WEBPACK FOOTER //
// ./src/api/index.js